import { ReactNode } from 'react'

import { SurveyResponse } from '@forto-dev/notification-center-models'

import { SurveyQuestionResponse } from './surveyQuestionResponse'
import { CheckboxSurveyQuestion } from '../../survey/CheckboxSurveyQuestion'
import { FreeTextSurveyQuestion } from '../../survey/FreeTextSurveyQuestion'
import { InlineButtonSurveyQuestion } from '../../survey/InlineButtonSurveyQuestion'
import { RadioSurveyQuestion } from '../../survey/RadioSurveyQuestion'

export type SurveyChoiceDescriptor = SurveyResponse
export type ExtendedSurveyResponse = SurveyChoiceDescriptor & {
  render?: (props: SurveyChoiceDescriptor) => ReactNode
}
export type ExtendedSurveyQuestion = SurveyChoiceDescriptor & {
  render?: (props: SurveyChoiceDescriptor) => ReactNode
  responses: ExtendedSurveyResponse[]
}

export enum SubmitLabel {
  done = 'done',
  next = 'next',
}

/**
 * Will be used to construct the actual survey questions and logic
 */
export type SurveyQuestionConfig = ExtendedSurveyQuestion & {
  component:
    | typeof RadioSurveyQuestion
    | typeof CheckboxSurveyQuestion
    | typeof InlineButtonSurveyQuestion
    | typeof FreeTextSurveyQuestion
  prefix?: ReactNode
  submitLabel?: SubmitLabel
  onSubmit: (state: SurveyQuestionResponse) => void
}

/**
 * Note: We don't support `touched` as a status, it's not yet necessary for the survey implementation
 */
export enum SurveyQuestionStatus {
  unanswered = 'unanswered',
  answered = 'answered',
}
export type SurveyQuestionChangeEvent = {
  surveyQuestionResponse: SurveyQuestionResponse
  status: SurveyQuestionStatus
}
export type SurveyQuestionProps = {
  question: ExtendedSurveyQuestion
  onChange: (event: SurveyQuestionChangeEvent) => void
}
